import { ChangeDetectorRef, Component, OnInit, inject } from '@angular/core';
import { ProductUid } from '@constants';

import { CommonModule } from '@angular/common';
import { MatIconModule } from '@angular/material/icon';
import { MatTooltipModule } from '@angular/material/tooltip';
import { RouterLink } from '@angular/router';
import { LoadingSkeletonComponent } from '@components';
import { ContentService, Product, ProductService } from '@services';
import { Observable, tap } from 'rxjs';
import { GknRoutePath } from 'src/app/app-routing.enum';
import { ProductsDirective } from '../../../@shared/directives/products.directive';
import { HomeFundamentalsCardComponent } from '../home-fundamentals-card/home-fundamentals-card.component';
import { HomeFundamentalsCardType } from '../home-fundamentals-card/home-fundamentals-card.enum';
import { HomeRoadmapsWysiwygComponent } from './home-fundamentals-roadmaps-wysiwyg/home-roadmaps-wysiwyg.component';

@Component({
    selector: 'app-home-fundamentals-roadmaps',
    templateUrl: './home-fundamentals-roadmaps.component.html',
    styleUrls: ['./home-fundamentals-roadmaps.component.scss'],
    imports: [
        CommonModule,
        HomeFundamentalsCardComponent,
        LoadingSkeletonComponent,
        MatIconModule,
        MatTooltipModule,
        RouterLink,
        ProductsDirective,
        HomeRoadmapsWysiwygComponent,
    ],
})
export class HomeFundamentalsRoadmapsComponent implements OnInit {
    private contentService = inject(ContentService);
    private cdr = inject(ChangeDetectorRef);
    private productService = inject(ProductService);

    cardType = HomeFundamentalsCardType.ROADMAPS;
    selectedProduct$: Observable<Product>;
    productEnum = ProductUid;
    routeEnum = GknRoutePath;
    roadmaps$: Observable<string>;
    isLoading = true;

    ngOnInit() {
        this.selectedProduct$ = this.productService.selectedProduct$;

        this.roadmaps$ = this.contentService.roadmaps$.pipe(
            tap(() => {
                this.isLoading = false;
                this.cdr.detectChanges();
            }),
        );
    }
}
